export default class DiscussionStats {
  public totalPoints: number = null;
  public postPoints: number = null;
  public postsMade: number = null;
  public reactionPoints: number = null;
  public reactionCount: number = null;
}
